import Vue from 'vue'
import Router, {Route} from 'vue-router'
import Login from '@/components/login/Login'
import ApplicationShell from '@/components/applicationShell/ApplicationShell'
import CalendarShifts from '@/components/calendarShifts/CalendarShifts'
import Communications from '@/components/communications/Communications'
import CommunicationsCampaign from '@/components/communications/campaign/CommunicationsCampaign'
import Shift from '@/components/shift/Shift'
import NewShift from '@/components/newShift/newShift'
import Facilities from '@/components/facilities/Facilities'
import FacilitiesAdvancedSearch from '@/components/facilities/FacilitiesAdvancedSearch'
import Facility from '@/components/facility/Facility'
import Invoice from '@/components/invoice/Invoice';
import PotentialInvoice from '@/components/invoice/PotentialInvoice';
import Provider from '@/components/provider/Provider'
import Providers from '@/components/providers/Providers'
import ProvidersAdvancedSearch from '@/components/providers/ProvidersAdvancedSearch'
import ProviderPayments from '@/components/payments/ProviderPayments';
import Payments from '@/components/payments/Payments';
import ReleaseNotes from '@/components/about/releaseNotes/ReleaseNotes';
import Reports from '@/components/reports/Reports';

import Invoices from '@/components/invoices/Invoices';
import Settings from '@/components/settings/Settings';
import Tasks from '@/components/tasks/Tasks';
import DelegatedTasks from '@/components/tasks/delegated/DelegatedTasks';
import Store from '@/store'
import TasksAdvancedSearch from "@/components/tasks/TasksAdvancedSearch";
import PreInvoiceMerge from "@/components/invoice/merge/PreInvoiceMerge";
import MergedInvoice from "@/components/invoice/MergedInvoice";
import {reportRegisters} from "@/components/reports/reportRegistry";
import Token from "@/components/login/Token.vue";

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'ApplicationShell',
      component: ApplicationShell,
      redirect: '/calendar-shifts',
      children: [
        {
          path: '/calendar-shifts',
          name: 'CalendarShifts',
          component: CalendarShifts
        },
        {
          path: '/shifts/new-shift',
          name: 'NewShift',
          component: NewShift
        },
        {
          path: '/shifts/:shiftId',
          name: 'Shift',
          component: Shift
        },
        {
          path: '/facilities',
          name: 'Facilities',
          component: Facilities
        },
        {
          path: '/facilities/advanced-search',
          name: 'FacilitiesAdvancedSearch',
          component: FacilitiesAdvancedSearch
        },
        {
          path: '/facilities/new-facility',
          name: 'NewFacility',
          component: Facility,
          props: { default: true, 'new-facility': true }
        },
        {
          path: '/facilities/:facilityId',
          name: 'Facility',
          component: Facility,
          props: true
        },
        {
          path: '/facilities/:facilityId/specialties/:specialtyId',
          name: 'FacilitySpecialty',
          component: Facility
        },
        {
          path: '/facilities/:facilityId/specialties/:specialtyId/invoices/date/:invoiceDate',
          name: 'PotentialInvoice',
          component: PotentialInvoice,
          props: true
        },
        {
          path: '/invoices/merged/:mergedInvoiceId',
          name: 'MergedInvoice',
          component: MergedInvoice,
          props: true
        },
        {
          path: '/facilities/:facilityId/specialties/:specialtyId/invoices/date/:invoiceDate/merge',
          name: 'SelectedPreInvoiceMerge',
          component: PreInvoiceMerge,
          props: true
        },
        {
          path: '/invoices/merged/:mergedInvoiceId/merge',
          name: 'UpdatePreInvoiceMerge',
          component: PreInvoiceMerge,
          props: true
        },
        {
          path: '/invoices/merge',
          name: 'PreInvoiceMerge',
          component: PreInvoiceMerge,
          props: true
        },
        {
          path: '/invoices/:invoiceId',
          name: 'Invoice',
          component: Invoice,
          props: true
        },
        {
          path: '/provider-payments',
          name: 'ProviderPayments',
          component: ProviderPayments
        },
        {
          path: '/payments',
          name: 'Payments',
          component: Payments
        },
        {
          path: '/providers',
          name: 'Providers',
          component: Providers
        },
        {
          path: '/providers/advanced-search',
          name: 'ProvidersAdvancedSearch',
          component: ProvidersAdvancedSearch
        },
        {
          path: '/providers/new-provider',
          name: 'NewProvider',
          component: Provider,
          props: { default: true, 'new-provider': true }
        },
        {
          path: '/providers/:providerId',
          name: 'Provider',
          component: Provider,
          props: true
        },
        {
          path: '/communications',
          name: 'Communications',
          component: Communications
        },
        {
          path: '/communications/new-campaign/:recipientTypeId/:messageTypeText',
          name: 'NewCommunicationsCampaign',
          component: CommunicationsCampaign,
          props:true
        },
        {
          path: '/invoices',
          name: 'Invoices',
          component: Invoices
        },
        {
          path: '/delegated-tasks',
          name: 'DelegatedTasks',
          component: DelegatedTasks,
          props: true
        },
        {
          path: '/tasks/advanced-search',
          name: 'TasksAdvancedSearch',
          component: TasksAdvancedSearch
        },
        {
          path: '/tasks/:userId?',
          name: 'Tasks',
          component: Tasks,
          props: true
        },
        {
          path: '/settings',
          name: 'Settings',
          component: Settings
        },
        {
          path: '/about',
          name: 'about',
          component: ReleaseNotes
        },
        {
          path: '/reports',
          name: 'Reports',
          component: Reports,
          children: reportRegisters
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logged-in',
      name: 'Token',
      component: Token
    }
  ]
});

// TODO comment the beejeezus out of this so others know how it works.
router.beforeEach( function (to, from, next) {
  const token = (Store.state as any).user.token;
  const tokenExpired = Store.getters['user/isTokenExpired']();
  if ((!token || tokenExpired) && to.name !== 'Login' && to.name !== 'Token') {
    setRedirect(to);
    next({
      name: 'Login',
    });
  } else {
    if (to.name !== 'Login' && to.name !== 'Token') {
      setRedirect(to);
    }
    next();
  }
});

function setRedirect(route: Route) {
  // Set the last "from" route in vuex
  // This will be used on login to re-navigate to the user's last view.
  Store.commit('user/setLastRoute', route.fullPath);
}

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/router/index.ts